<ng-template #LoginHelpModal let-modal>
     <div class="modal-header">
          <h3 id="loginHelpModalTitle" class="modal-title" [innerHTML]="'LoginAssistance' | translator:'base'"
               slot="header">Login Assistance</h3>
     </div>
     <div class="modal-body">
          <div role="alert">
               <p [innerHTML]="'LoginAssist1' | translator:'base'">Hi. Oftentimes when
                    people are having trouble logging into PSP, it is because they have
                    either forgotten their password or because their account has become
                    locked. We have put together a short video below to show how you can
                    fix these issues.</p>
               <p [innerHTML]="'LoginAssist2' | translator:'base'">If the video does not
                    help your issue, please close this window and you can continue filling
                    out the contact form.</p>
          </div>
          <p class="d-flex align-items-center m-0">
               <a href="https://tylertech.wistia.com/medias/h32vcocq9r" target="_blank"
                    [attr.aria-label]="'PasswordVideoTitle' | translator:'base'"
                    [title]="'PasswordVideoTitle' | translator:'base'" id="forgotPwdVideo" name="forgotPwdVideo">
                    <i class="fa-solid fa-circle-play me-2" aria-hidden="true"></i><span
                         [innerHTML]="'PasswordVideo' | translator:'base'">Password not
                         working?</span>
               </a>
          </p>
     </div>

     <div class="modal-footer">
          <button class="btn btn-outline-primary" (click)="hideLoginHelp()" [title]="'Close' | translator:'base'"
               name="Close" id="Close">
               <span [innerHTML]="'Close' | translator:'base'">Close</span>&nbsp;
          </button>
     </div>
</ng-template>

<div>
     <div class="overlay" *ngIf="sendingMessage">
          <h1 class="heading" [innerHTML]="'Sending' | translator:'base'">Sending...</h1>
          <img />
     </div>

     <div *ngIf="messageSentError === false && messageSentSuccess == false">
          <h2 class="h4" [innerHTML]="'ContactForm' | translator:'base'">Contact Form</h2>
          <div class="row gx-2">
               <div *ngIf="!messageSentError && !messageSentSuccess">
                    <div class="row gx-2" [formGroup]="contactInfo">
                         <div class="col-12 mb-3">
                              <label for="contactName" class="form-label">
                                   <span [innerHTML]="'Name' | translator:'base'">Name</span>
                                   <span class="text-danger ms-1" [title]="'Required' | translator:'base'">*</span>
                              </label>
                              <input [title]="'Name' | translator:'base'" class="form-control" type="text"
                                   id="contactName" name="contactName" formControlName="contactName" />

                              <div *ngIf="contactName_!.invalid && contactName_!.dirty" class="help-block text-danger">
                                   <div *ngIf="contactName_!.errors?.['required']"
                                        [innerHTML]="'ContactName_required' | translator:'base'">
                                   </div>
                                   <div *ngIf="contactName_!.errors?.['maxlength']"
                                        [innerHTML]="'ContactName_max' | translator:'base'">
                                   </div>
                                   <div *ngIf="contactName_!.errors?.['pattern']"
                                        [innerHTML]="'ContactName_invalid' | translator:'base'">
                                   </div>
                              </div>
                         </div>
                         <div class="col col-6 mb-3 pe-2">
                              <label for="email" class="form-label">
                                   <span [innerHTML]="'Email' | translator:'base'">Email</span>
                                   <span class="text-danger ms-1" [title]="'Required' | translator:'base'">*</span>
                              </label>
                              <input [title]="'Email' | translator:'base'" class="form-control" type="email" id="email"
                                   name="email" formControlName="email" />
                              <div *ngIf="email_!.invalid && email_!.dirty" class="help-block text-danger">
                                   <div *ngIf="email_!.errors?.['required']"
                                        [innerHTML]="'UserEmail_required' | translator:'base'">
                                   </div>
                                   <div *ngIf="email_!.errors?.['maxlength']"
                                        [innerHTML]="'DriverEmail_max' | translator:'base'">
                                   </div>
                                   <div *ngIf="email_!.errors?.['pattern']"
                                        [innerHTML]="'User_Email_invalid' | translator:'base'">
                                   </div>
                              </div>
                         </div>
                         <div class="col col-6 mb-3 ps-2">
                              <label for="phoneNumber" class="form-label">
                                   <span [innerHTML]="'Phone Number' | translator:'base'">Phone Number</span>
                                   <span class="text-danger ms-1" [title]="'Required' | translator:'base'">*</span>
                              </label>
                              <input [title]="'Phone Number' | translator:'base'" class="form-control" type="tel"
                                   id="phoneNumber" name="phoneNumber" formControlName="phoneNumber"
                                   mask="(000) 000-0000" placeholder="(___) ___-____" />
                              <div *ngIf="phoneNumber_!.invalid && phoneNumber_!.dirty" class="help-block text-danger">
                                   <div *ngIf="phoneNumber_!.errors?.['required']"
                                        [innerHTML]="'Phone_required' | translator:'base'">
                                   </div>
                                   <div *ngIf="phoneNumber_!.errors?.['maxlength']"
                                        [innerHTML]="'Phone_required' | translator:'base'">
                                   </div>
                                   <div *ngIf="phoneNumber_!.errors?.['pattern']"
                                        [innerHTML]="'PhoneNumber_format' | translator:'base'">
                                   </div>
                              </div>
                         </div>
                         <div class="col-12 mb-3">
                              <label for="topic" class="form-label">
                                   <span [innerHTML]="'Topic' | translator:'base'">Topic</span>
                                   <span class="text-danger ms-1" [title]="'Required' | translator:'base'">*</span>
                              </label>
                              <select formControlName="topic" id="topic" name="topic" required
                                   class="form-select rounded-0" [title]="'Topic' | translator:'base'"
                                   (change)="topicChanged()" [(ngModel)]="topic">
                                   <option [selected]="!topic" [innerHTML]="'SelectOption' | translator:'base'"
                                        value="">
                                        Select...
                                   </option>
                                   <option value="login" [innerHTML]="'LoginOption' | translator:'base'">
                                        Login issues
                                   </option>
                                   <option value="account" [innerHTML]="'AccountOption' | translator:'base'">
                                        Account updates
                                   </option>
                                   <option value="billing" [innerHTML]="'BillingOption' | translator:'base'">
                                        Billing
                                   </option>
                                   <option value="website" [innerHTML]="'WebsiteOption' | translator:'base'">
                                        Website issues
                                   </option>
                                   <option value="other" [innerHTML]="'OtherOption' | translator:'base'">
                                        Other
                                   </option>
                                   <option *ngIf="topicIn !== ''" [value]="topicIn">
                                        {{topicIn}}
                                   </option>
                              </select>
                              <span class="help-block text-danger" *ngIf="topic_!.invalid && topic_!.dirty"
                                   [innerHTML]="'Topic_required' | translator:'base'">
                                   Topic is required.
                              </span>
                         </div>
                         <div class="col-12 mb-3">
                              <label for="message" class="form-label">
                                   <span [innerHTML]="'Message' | translator:'base'">Message</span>
                                   <span class="text-danger ms-1" [title]="'Required' | translator:'base'">*</span>
                              </label>
                              <textarea formControlName="message" [title]="'Message' | translator:'base'"
                                   class="form-control" id="message" name="message">
                              </textarea>
                              <div *ngIf="message_!.invalid && message_!.dirty" class="help-block text-danger">
                                   <div *ngIf="message_!.errors?.['required']"
                                        [innerHTML]="'Message_required' | translator:'base'">
                                   </div>
                                   <div *ngIf="message_!.errors?.['maxlength']"
                                        [innerHTML]="'Message_max' | translator:'base'">
                                   </div>
                                   <div *ngIf="message_!.errors?.['pattern']"
                                        [innerHTML]="'Message_invalid' | translator:'base'">
                                   </div>
                              </div>
                         </div>
                         <div class="col-12">
                              <button class="btn btn-primary btn-strong" [innerHTML]="'Send' | translator:'base'"
                                   [title]="'Send' | translator:'base'" (click)="sendMessage()" [disabled]="isValued"
                                   id="sendMessage" name="sendMessage">
                                   Send
                              </button>
                         </div>
                    </div>
               </div>
          </div>
     </div>
     <div class="col-12" *ngIf="messageSentSuccess === true">
          <div class="alert alert-success m-0">
               <h2 [innerHTML]="'ConfirmationHeader' | translator:'base'">Confirmation</h2>
               <p [innerHTML]="'MessageSentSuccess' | translator:'base'">
                    Thank you for contacting the PSP customer service team. We will respond to
                    you within one business day.
               </p>
          </div>
     </div>
     <div class="col-12" *ngIf="messageSentError === true">
          <div class="alert alert-danger m-0">
               <h2 [innerHTML]="'Error' | translator:'base'">Error</h2>
               <p [innerHTML]="'MessageSentError' | translator:'base'">
                    An error occurred sending your message. Please email us at <a href="mailto:PSPhelp@tylertech.com"
                       title="PSPhelp@tylertech.com">PSPhelp&#64;tylertech.com</a>.
               </p>
          </div>
     </div>
</div>